export const COUNTRIES: {[code: string]: string} = {
  "AE": "ОАЭ",
  "AR": "Аргентина",
  "AU": "Австралия",
  "BR": "Бразилия",
  "CA": "Канада",
  "CH": "Швейцария",
  "CL": "Чили",
  "CN": "Китай",
  "CO": "Колумбия",
  "CR": "Коста-Рика",
  "DE": "Германия",
  "GB": "Великобритания",
  "HK": "Гонконг",
  "ID": "Индонезия",
  "IL": "Израиль",
  "IN": "Индия",
  "JP": "Япония",
  "KR": "Южная Корея",
  "KW": "Кувейт",
  "KZ": "Казахстан",
  "MX": "Мексика",
  "MY": "Малайзия",
  "NO": "Норвегия",
  "NZ": "Новая Зеландия",
  "PE": "Перу",
  "PH": "Филиппины",
  "PK": "Пакистан",
  "PL": "Польша",
  "QA": "Катар",
  "RU": "Россия",
  "SA": "Саудовская Аравия",
  "SG": "Сингапур",
  "TH": "Таиланд",
  "TR": "Турция",
  "TW": "Тайвань",
  "UA": "Украина",
  "US": "США",
  "UY": "Уругвай",
  "UZ": "Узбекистан",
  "VN": "Вьетнам",
  "ZA": "Южная Африка"
}